module.exports = __webpack_public_path__ + "img/boiler-plant-md.08f850d4.svg";